<template>
  <div>
    <div class="card p-4">
      <div class="title px-4 pb-2 pt-4">
        <div class="d-flex">
          <div>
            <h4>{{ $t("lang.label.changeyourpassword") }}</h4>
          </div>
        </div>
      </div>
      <div class="body p-4">
        <div class="input-group mb-3">
          <label for="CurrentPassword" class="col-12 col-sm-4 col-form-label">{{
            $t("lang.label.currentpassword")
          }}</label>
          <input
            type="password"
            class="form-control"
            id="CurrentPassword"
            v-model="passwords.currentPass"
          />
          <div class="input-group-append">
            <button
              class="btn btn-outline-link"
              type="button"
              id="button-addon2"
              @mousedown="showText('CurrentPassword')"
              @mouseup="hideText('CurrentPassword')"
              @mouseout="hideText('CurrentPassword')"
            >
              <span class="icon-eye"></span>
            </button>
          </div>
        </div>
        <div class="input-group mb-3">
          <label for="NewPassword" class="col-12 col-sm-4 col-form-label">{{
            $t("lang.label.newpassword")
          }}</label>
          <input
            type="password"
            class="form-control"
            id="NewPassword"
            v-model="passwords.newPass"
          />
          <div class="input-group-append">
            <button
              class="btn btn-outline-link"
              type="button"
              id="button-addon2"
              @mousedown="showText('NewPassword')"
              @mouseup="hideText('NewPassword')"
              @mouseout="hideText('NewPassword')"
            >
              <span class="icon-eye"></span>
            </button>
          </div>
        </div>
        <div class="input-group mb-3">
          <label for="ConfirmPassword" class="col-12 col-sm-4 col-form-label">{{
            $t("lang.label.confirmpassword")
          }}</label>
          <input
            type="password"
            class="form-control"
            id="ConfirmPassword"
            v-model="passwords.newPassValid"
          />
          <div class="input-group-append">
            <button
              class="btn btn-outline-link"
              type="button"
              id="button-addon2"
              @mousedown="showText('ConfirmPassword')"
              @mouseup="hideText('ConfirmPassword')"
              @mouseout="hideText('ConfirmPassword')"
            >
              <span class="icon-eye"></span>
            </button>
          </div>
        </div>
        <div
          class="alert alert-danger alert-dismissible fade show"
          role="alert"
          v-if="errorPass.length"
        >
          <ul>
            <li><strong>Error!</strong></li>
            <li v-for="(error, key) in errorPass" :key="key">
              {{ error }}
            </li>
          </ul>
          <button
            type="button"
            class="close"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="my-4 text-right mr-4">
          <button class="btn btn-success btn-sm" @click="validate()">
            {{ $t("lang.button.confirmnewpassword") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { usersService } from "@/_services";
import Multiselect from "vue-multiselect";
import $ from "jquery";

Vue.component("multiselect", Multiselect);

export default {
  props: {
    user_id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      errorPass: [],
      passwords: {
        currentPass: "",
        newPass: "",
        newPassValid: "",
      },
      loading: true,
    };
  },

  components: {
    LoadingSpinner,
  },

  computed: {
    user() {
      return this.$store.state.authentication.user;
    },
  },

  methods: {
    showText(id) {
      $("#" + id).prop("type", "text");
    },

    hideText(id) {
      $("#" + id).prop("type", "password");
    },

    validatePasswords() {
      return this.passwords.newPass === this.passwords.newPassValid;
    },

    checkFildsPass() {
      this.errorPass = [];
      if (!this.passwords.currentPass) {
        this.errorPass.push("The field Current Password can not be blank.");
        return false;
      }
      if (!this.passwords.newPass) {
        this.errorPass.push("The field New Password can not be blank.");
        return false;
      }
      if (!this.passwords.newPassValid) {
        this.errorPass.push("The field Confirm Password can not be blank.");
        return false;
      }
      if (
        !/^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,}).{6,16}$/.test(
          this.passwords.newPass
        )
      ) {
        this.errorPass.push(this.$t("lang.validation.password"));
        return false;
      }
      if (!this.validatePasswords()) {
        this.errorPass.push(
          "The filds New Password and Confirm Password are different."
        );
        return false;
      }
      if (!this.errorPass.length) {
        return true;
      }
    },

    validate() {
      let valid = this.checkFildsPass();
      if (valid) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.changepassword"),
          text: "",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: "Ok",
        }).then((result) => {
          if (result.value) {
            this.changePass();
          }
        });
      }
    },
    changePass() {
      usersService
        .changePassword(
          this.user_id,
          this.passwords.currentPass,
          this.passwords.newPassValid
        )
        .then(
          (result) => {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.passwordchangedsuccessfully"),
              showConfirmButton: false,
              timer: 1500,
            });
          },
          (error) => {
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: true,
            });
          }
        );
    },
  },
};
</script>